import { ExamType } from '../../api/exam';
import Segment from '../shared/segment';
import Field from '../shared/field';
import { useBooleanState } from '../../hooks/index/use-boolean-state';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { ChevronUpIcon } from '@heroicons/react/24/solid';

export type ExamHeaderPropsType = {
  exam: ExamType;
  timer: ReactNode;
};

function ExamHeader({ exam, timer }: ExamHeaderPropsType) {
  const { value: showMore, toggle: toggleShowMore } = useBooleanState(false);

  return (
    <Segment bg noPad noMargin color='green' className='sticky top-0'>
      <div className='grid gap-1 px-4 sm:py-2 md:grid-cols-3'>
        <Field title='نام آزمون' content={exam.name} className='md:col-span-2' />
        {timer}
        <Field
          title='زمان آزمون'
          content={`${exam.duration} دقیقه`}
          className={classNames({ 'hidden md:block': !showMore })}
        />
        <Field
          title='تعداد سوالات'
          content={exam.questionCount}
          className={classNames({ 'hidden md:block': !showMore })}
        />
        <Field
          title='نمره منفی'
          content={exam.penalty ? 'دارد' : 'ندارد'}
          className={classNames({ 'hidden md:block': !showMore })}
        />
      </div>
      <div className='md:hidden'>
        {showMore ? (
          <ChevronUpIcon width={16} height={16} className='mx-auto' onClick={toggleShowMore} />
        ) : (
          <ChevronDownIcon width={16} height={16} className='mx-auto' onClick={toggleShowMore} />
        )}
      </div>
    </Segment>
  );
}

export default ExamHeader;
